'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _lodash = require('lodash');
var _reactScroll = require('react-scroll');

var _CommodityCard = require('./CommodityCard');var _CommodityCard2 = _interopRequireDefault(_CommodityCard);
var _CommodityBlock = require('./CommodityBlock');var _CommodityBlock2 = _interopRequireDefault(_CommodityBlock);
var _constants = require('./constants');
var _validate = require('./validate');
var _helpers = require('./helpers');
var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var styles = _interopRequireWildcard(_PublishNewHomesForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ProjectCommodities = function (_Component) {_inherits(ProjectCommodities, _Component);function ProjectCommodities() {var _temp, _this, _ret;_classCallCheck(this, ProjectCommodities);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      options: (0, _helpers.getInitialOptionsConfig)(_this.props.translate) }, _this.


    renderFields = function (_ref) {var fields = _ref.fields,meta = _ref.meta;var _this$props =
      _this.props,translate = _this$props.translate,name = _this$props.name,replaceAt = _this$props.replaceAt,isRtl = _this$props.isRtl;
      var canAddCommodityType = fields.length < _constants.MAX_COMMODITY_TYPES;

      var handleAddCommodity = function handleAddCommodity() {return fields.push(_constants.initialCommodityValue);};

      return (
        _react2.default.createElement('div', { className: styles.commodities },
          _react2.default.createElement('span', { className: styles.label },
            translate('addNewProject', 'commodities')),

          _react2.default.createElement('div', { className: styles.inputs },
            fields.map(function (commodity, index) {
              var items = (0, _lodash.get)(fields.get(index), 'items');
              var commodityType = (0, _lodash.get)(fields.get(index), 'type');
              var canAddCommodity = (items || []).length < _constants.MAX_COMMODITIES;
              var hasCommodities = items && items.length > 0;

              var handleRemoveCommodity = function handleRemoveCommodity() {return fields.remove(index);};

              var handleRemoveItem = function handleRemoveItem(text) {
                replaceAt(name, index, {
                  type: commodityType,
                  items: items.filter(function (val) {return val !== text;}) });

              };

              var handleAddItem = function handleAddItem(content) {
                replaceAt(name, index, {
                  type: commodityType || '',
                  items: [].concat(items, [content]) });

              };

              var handleSelect = function handleSelect(_ref2) {var value = _ref2.value;
                replaceAt(name, index, {
                  type: value,
                  items: items });

                _this.setState(function (prev) {return Object.assign({},
                  prev, {
                    options: (0, _helpers.getOptions)(prev.options, fields.getAll(), commodityType, translate) });});

              };

              return (
                _react2.default.createElement(_CommodityBlock2.default, {
                    name: commodity,
                    isRtl: isRtl,
                    key: commodity,
                    translate: translate,
                    canAddCommodity: canAddCommodity,
                    value: commodityType,
                    options: (0, _helpers.getOptions)(_this.state.options, fields.getAll(), commodityType, translate),
                    onSelect: handleSelect,
                    onClick: handleAddItem,
                    onRemove: handleRemoveCommodity,
                    index: index,
                    hasError: !!meta.error && !!meta.error[index] && meta.submitFailed && meta.touched,
                    error: !!meta.error && meta.error[index] },

                  hasCommodities &&
                  _react2.default.createElement('div', { className: styles.extrasWrapper },
                    items.map(function (text, idx) {
                      var key = text + '-' + idx;
                      return (
                        _react2.default.createElement(_CommodityCard2.default, {
                          key: key,
                          content: text,
                          onClick: handleRemoveItem }));


                    }))));




            }),
            canAddCommodityType && _react2.default.createElement('button', {
                className: styles.addObject,
                onClick: handleAddCommodity,
                type: 'button',
                disabled: !canAddCommodityType },

              _react2.default.createElement('span', { className: styles.plus }, '+'),
              translate('addNewProject', 'addObject')))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}ProjectCommodities.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_reactScroll.Element, { name: this.props.name, className: styles.commoditiesWrapper },
        _react2.default.createElement(_reduxForm.FieldArray, {
          name: this.props.name,
          component: this.renderFields,
          validate: _validate.commodityValidator })));



  };return ProjectCommodities;}(_react.Component);exports.default = ProjectCommodities;


ProjectCommodities.propTypes = {
  push: _propTypes2.default.func.isRequired,
  remove: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func.isRequired,
  fields: _propTypes2.default.object,
  changeValue: _propTypes2.default.func.isRequired,
  replaceAt: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/ProjectCommodities.js
// module id = 3034
// module chunks = 0